import { createFetchOptions } from '../config';

interface ApiErrorPayload {
  error?: string;
  message?: string;
}

export async function fetchJson<T>(url: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(url, createFetchOptions(options));
  const contentType = response.headers.get('content-type') ?? '';
  const isJson = contentType.includes('application/json');
  const payload = isJson ? ((await response.json()) as T | ApiErrorPayload) : null;

  if (!response.ok) {
    const errorMessage =
      payload && typeof payload === 'object' && payload !== null
        ? ('error' in payload && payload.error) || ('message' in payload && payload.message)
        : undefined;

    throw new Error(errorMessage || `Request failed with status ${response.status}`);
  }

  return payload as T;
}
